import { render, staticRenderFns } from "./AddPhoto.vue?vue&type=template&id=8e68e980"
import script from "./AddPhoto.vue?vue&type=script&lang=ts"
export * from "./AddPhoto.vue?vue&type=script&lang=ts"
import style0 from "./AddPhoto.vue?vue&type=style&index=0&id=8e68e980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports